import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/styles/site-theme.css'
import App from './App.vue'

import '@/utils/rem.js'
import router from "@/router";

const app = createApp(App)

app.use(ElementPlus)

app.use(router)

app.mount('#app')


